import type { IconData } from '@stacksjs/iconify-core'

export const fax: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M487.944 233.654L424 176.815V89.373L350.627 16H152v128H80a24.03 24.03 0 0 0-24 24v304a24.03 24.03 0 0 0 24 24h416V251.593a24.02 24.02 0 0 0-8.056-17.939M152 464H88V176h64ZM328 48h9.373L392 102.627V112h-64Zm-144 0h112v96h96v72H184Zm280 416H184V248h240v-28.371l40 35.557Z\"/><path fill=\"currentColor\" d=\"M232 344h32v32h-32zm64 0h32v32h-32zm-64 64h32v32h-32zm64 0h32v32h-32zm64-64h32v32h-32zm0 64h32v32h-32zM232 280h160v32H232z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default fax
